module.exports = __webpack_public_path__ + "media/images/sign_up_bg-a55d2eee.jpg";